import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-empty-state',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="empty-state">
      @if (icon()) {
        <span class="material-symbols-outlined empty-icon" aria-hidden="true">
          {{ icon() }}
        </span>
      }
      <h3 class="empty-title">{{ title() }}</h3>
      @if (message()) {
        <p class="empty-message">{{ message() }}</p>
      }
      <div class="empty-actions">
        <ng-content />
      </div>
    </div>
  `,
  styles: `
    .empty-state {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 3rem 1.5rem;
      text-align: center;
    }

    .empty-icon {
      font-size: 3rem;
      color: oklch(0.7 0 0);
      margin-bottom: 1rem;
    }

    .empty-title {
      margin: 0;
      font-size: 1.125rem;
      font-weight: 600;
      color: oklch(0.3 0 0);
    }

    .empty-message {
      margin: 0.5rem 0 0;
      font-size: 0.875rem;
      color: oklch(0.5 0 0);
      max-width: 24rem;
    }

    .empty-actions {
      margin-top: 1.5rem;
    }

    .empty-actions:empty {
      display: none;
    }
  `,
})
export class EmptyStateComponent {
  readonly icon = input<string>();
  readonly title = input.required<string>();
  readonly message = input<string>();
}
